<div class="rounded-2xl bg-yellow-200 px-4 py-2 w-full space-y-2 text-gray-900">
  <div class="flex items-center gap-2">
    <app-icon name="mobile" class="w-5 h-5 text-gray-600" />
    <span class="text-gray-600">Operating System:</span>
    <span class="font-semibold">{{ order().operatingSystem ?? 'N/A' }}</span>
  </div>
  <div class="flex items-center gap-2">
    <app-icon name="git" class="w-5 h-5 text-gray-600" />
    <span class="text-gray-600">OS Version:</span>
    <span class="font-semibold">{{ order().operatingSystemVersion ?? 'N/A' }}</span>
  </div>
  <div class="flex items-center gap-2">
    <app-icon name="mobile" class="w-5 h-5 text-gray-600" />
    <span class="text-gray-600">Device:</span>
    <span class="font-semibold">{{ order().device ?? 'N/A' }}</span>
  </div>
  <div class="flex items-center gap-2">
    <app-icon name="git" class="w-5 h-5 text-gray-600" />
    <span class="text-gray-600">App Version:</span>
    <span class="font-semibold">{{ order().appVersion ?? 'N/A' }}</span>
  </div>
</div>
